"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const ConfirmDialog_vue_1 = require("@/client/components/common/ConfirmDialog.vue");
const GoToMap_vue_1 = require("@/client/components/waitingFor/GoToMap.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'SelectSpace',
    props: {
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
            required: true,
        },
        showtitle: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            spaces: new Set(this.playerinput.spaces),
            selectedTile: undefined,
            spaceId: undefined,
            warning: undefined,
        };
    },
    components: {
        'confirm-dialog': ConfirmDialog_vue_1.default,
        GoToMap: GoToMap_vue_1.default,
    },
    computed: {
        typedRefs() {
            return this.$refs;
        },
    },
    methods: {
        animateSpace(tile, activate) {
            if (activate) {
                tile.classList.add('board-space--available');
            }
            else {
                tile.classList.remove('board-space--available');
            }
        },
        animateSpaces(tiles) {
            tiles.forEach((tile) => {
                const spaceId = tile.getAttribute('data_space_id');
                if (spaceId !== null && this.spaces.has(spaceId)) {
                    this.animateSpace(tile, true);
                }
            });
        },
        cancelPlacement() {
            if (this.selectedTile === undefined) {
                throw new Error('unexpected, no tile selected!');
            }
            this.animateSpace(this.selectedTile, false);
            this.animateSpaces(this.getSelectableSpaces());
        },
        confirmPlacement() {
            const tiles = this.getSelectableSpaces();
            tiles.forEach((tile) => {
                tile.onclick = null;
            });
            if (this.selectedTile === undefined) {
                throw new Error('unexpected, no tile selected!');
            }
            const spaceId = this.selectedTile.getAttribute('data_space_id');
            if (spaceId === null) {
                throw new Error('unexpected, space has no id');
            }
            this.spaceId = spaceId;
            this.selectedTile.classList.add('board-space--selected');
            this.saveData();
        },
        disableAnimation() {
            const tiles = this.getSelectableSpaces();
            tiles.forEach((tile) => {
                tile.classList.remove('board-space--available', 'board-space--selected');
            });
        },
        getSelectableSpaces() {
            const spaces = [];
            const regions = ['main_board', 'moon_board', 'colony_spaces', 'moon_board_outer_spaces'];
            for (const region of regions) {
                const board = document.getElementById(region);
                if (board !== null) {
                    const array = board.getElementsByClassName('board-space-selectable');
                    for (let i = 0, length = array.length; i < length; i++) {
                        spaces.push(array[i]);
                    }
                }
            }
            return spaces;
        },
        hideDialog(hide) {
            PreferencesManager_1.PreferencesManager.INSTANCE.set('hide_tile_confirmation', hide);
        },
        onTileSelected(tile) {
            this.selectedTile = tile;
            this.disableAnimation();
            this.animateSpace(tile, true);
            tile.classList.remove('board-space--available');
            const hideTileConfirmation = (0, PreferencesManager_1.getPreferences)().hide_tile_confirmation;
            if (hideTileConfirmation) {
                this.confirmPlacement();
            }
            else {
                this.typedRefs.confirmation.show();
            }
        },
        saveData() {
            if (this.spaceId === undefined) {
                this.warning = 'Must select a space';
                return;
            }
            this.onsave({ type: 'space', spaceId: this.spaceId });
        },
    },
    mounted() {
        this.disableAnimation();
        const tiles = this.getSelectableSpaces();
        this.animateSpaces(tiles);
        for (let i = 0, length = tiles.length; i < length; i++) {
            const tile = tiles[i];
            const spaceId = tile.getAttribute('data_space_id');
            if (spaceId === null || this.spaces.has(spaceId) === false) {
                continue;
            }
            tile.onclick = () => this.onTileSelected(tile);
        }
    },
});
